
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//芬兰
export const lang ={
  Please_set_materialtype_in_product_page:"Siirry tuotesivulle muokataksesi ja asettaaksesi kunkin tuotteen materiaalityyppiä - valmiit tuotteet - puolivalmiit tuotteet - tarvikkeet.",
  deleteAccount:"Kirjautua ulos",
  deleteAccountWillDeleteAllData:"Kirjautuminen ulos tilistäsi poistaa kaikki tiedot ja estää kirjautumisen.",
  backupDatabase:"varmuuskopiotietokanta",
  restoreDatabase:"Palauta tietokanta",
  materialtype:"Materiaalityyppi",
  Manufacturing:"Valmistusversio",
  Professional:"Ammattimainen versio",
  Standard:"tavallinen versio",
  product:"Valmis tuote",
  halfProduct:"Puolivalmiit tuotteet",
  components:"Lisätarvikkeet",
  Parent:"emokomponentti",
  Children:"Lisävarusteet",
  Level:"Hierarkia",
  Timing:"Ajoitus",
  PieceCount:"Kappaletyö",
  Wages:"Palkat",
  InternalProcess:"Sisäinen prosessi",
  ExternalProcess:"ulkoinen prosessi",
  ProceName:"Prosessin nimi",
  ProceIndex:"Toteutusmääräys",
  ChargeMan:"rehtori",
  BillMethod:"Laskutustapa",
  ConsumTime:"työtunnit",
  Accessories:"Lisätarvikkeet",
  Assembly:"Koota",
  materials:"materiaaleja",
  task:"Tehtävä",
  process:"käsitellä asiaa",
  BOM:"BOM",
  Production:"Tuotanto",
  RestorePurchaseOneUse:"Palauta ostos (yksi käyttäjä (rajoitettu aikaisempiin ostoksiin))",
  buy_fail_try_again:"Napsauta uudelleen ostaaksesi",
  Export:"Viedä",
  Date:"Päivämäärä",
  BankDetail:"pankkitiedot",
  Seller:"myyjä",
  Buver:"ostaja",
  Currency:"valuutta",
  CompanyName:"Yrityksen nimi",
  ProformaInvoice:"proforma lasku",
  Discount:"Alennus",
  PayStatus:"Maksun tilanne",
  ShippingStatus:"Toimituksen tila",
  FreightType:"Kuljetustyyppi",
  Shipping:"rahti",
  Payment:"Maksu",
  Moneyname:"valuutan nimi",
  Tax:"verot",
  Freight:"Rahtikustannukset",
  Insurance:"vakuutus",
  Bankfee:"pankkimaksut",
  Qc:"Laatusertifikaatti",
  Exchangerate:"vaihtokurssi",
  Shippingnumber:"lähetysnumero",
  ShipDate:"Lähetyspäivä",
  Arrivedate:"Saapumispäivä",
  Grossweight:"bruttopaino",
  CubicWeight:"kuutiopaino",
  Totalpackages:"Pakettien kokonaismäärä",
  Moneytype:"valuutan tyyppi",
  Quotedate:"lainauspäivämäärä",
  Validitydate:"Kelvollinen päivämäärä",
  Paymentterm:"palkan vanheneminen",
  Priceterm:"hinnoitteluehto",
  DeliveryTerm:"Toimitusaika",
  BankName:"pankin nimi",
  BankAddress:"pankkiosoite",
  SwiftCode:"Pankkikoodi",
  Review:"Arvostelu",
  Signfor:"Allekirjoita kuitti",
  Finance:"Rahoittaa",
  Receiver:"Vastaanotin",
  Business:"liiketoimintaa",
  ContactPerson:"Yhteyshenkilö",
  Profit:"voitto",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:"Työntekijöiden on käytettävä Google Chromea. Tarkista IP-osoite pääpalvelutietokoneen APP:n ohjesivulta ja kirjoita sitten osoite muiden tietokoneselaimien URL-sarakkeeseen avataksesi kirjautumisen",
  newPassword:"uusi salasana",
  ForgetPassword:"unohda salasana",
  ContactUs:"Ota yhteyttä / tee ehdotuksia",
  Actualpay_should_big_then_shouldpay:"Todelliset tulot eivät voi olla saamisia suuremmat",
  ShopAddress:"Myymäläni osoite Skannaa QR-koodi tehdäksesi tilauksen",
  Submit:"Lähetä",
  All:"kaikki",
  OrdernumExists:"Tilausnumero on jo olemassa",
  PermissionDenied:"lupa kielletty",
  StockTransfer:"Osakkeiden siirto",
  FromWarehouse:"Siirto pois varastosta",
  ToWarehouse:"Siirto varastoon",
  PleaseUseInWebBrowser:"Käytä Google Chromen Excelin vientitoimintoa",
  PleasePrintInWebBrowser:"Käytä Google Chromen tulostustoimintoa",
  HistoryPrice:"historiallinen hinta",
  SerialNumber:"sarjanumero",
  Please_Use_In_APP:"Käytä sitä tietokoneohjelmistossa",
  Please_Purchase_In_APP:"Osta APP:sta, älä selaimesta",
  Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Voit muodostaa yhteyden Postgresql-tietokantaan. Tietosi tallennetaan Postgresql-tietokantaan. Oletuksena sinun ei tarvitse muodostaa yhteyttä Postgresql-tietokantaan. Oletus on paikallinen Sqlite-tietokanta.",
  Connect_Postgresql_database_data_will_store_in_Postgresql:"Yhdistä Postgresql-tietokantaan, tietosi tallennetaan Postgresql-tietokantaan ja tiedot luetaan uudelleen",
  Use_sqlite_data_will_store_in_local:"Sqlitea käyttämällä tiedot tallennetaan paikalliselle koneelle",
  UsePostgresqlDatabase:"PGSQL-tietokannan käyttö",
  UseSqliteDatabase:"Sqlite-tietokannan käyttö",
  DatabaseName:"Nimitietokanta",
  Test_connect:"testaa yhteys",
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Jos tuotteella on väriä tai kokoa, täytä alkuvarastoa varten 0. Kun olet lisännyt tuotteen, kirjoita varasto ostotapahtumaan.",
  my:"Kaivos",
  my_shop_qrcode_scan:"Myymäläni QR-koodi tarjoaa asiakkaille mahdollisuuden skannata koodi tilauksen tekemiseksi Asiakkaan matkapuhelimen tulee olla kytkettynä samaan reitittimeen kuin tietokoneesi.",
  ip:"IP",
  port:"Portti",
  orderstatus:"Tilauksen tila",
  image:"kuva",
  Template:"sapluuna",
  Please_select_a_excel_file:"Valitse tiedosto",
  Please_select_only_one_excel_file:"Vain yksi tiedosto voidaan valita",
  Connect_Internet_Login_again:"Yhdistä Internetiin ja kirjaudu uudelleen sisään ennen ostamista",

productHasValidDate:'Tuotteella on voimassa oleva aika',
productHasColor:'Tuotteessa on värikokoa',
GeneralGoods:'Yleiset tavarat',
Selected:'valittu',
RestorePurchase:'Jatka ostamista',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Osta laskutus Enterprise Edition 1 -käyttäjiä pysyvästi',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Ostolaskutus Enterprise Edition on rajoittamaton käyttäjille ja laitteille',
Purchasing:'Ostaminen ... Odota kärsivällisesti ...',
Validdate:'Voimassaolo',
Makedate:'Tuotantopäivämäärä',
Batch:'erä',
CheckVersion:'Tarkista versio',
Please_set_this_ip_address_on_App:'Aseta tämä IP-osoite tai IP-osoite APP: lle.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Avaa tämä yhteys tietokoneessa tai mobiililaitteessa (yhdistä sama WiFi)',
    CheckVersion: 'Tarkista versio',
You_need_to_purchase: 'Et ole vielä ostanut, lisää WeChat Elink9988-sähköpostiosoitteeseen: bvbuy@qq.com',
Kiitos_for_your_purchase: 'Olet jo ostanut',
New_version_available: 'On uusi versio',
Is_the_latest_version: 'on uusin versio',
    please:'ole kiltti',
input:'panos',
wrong:'väärä',
Verifycode:'Varmistus koodi',
Upload:'upload',
Download:'ladata',
You_need_to_purchase_to_continue_use:'Jatka käyttöä varten sinun täytyy ostaa',
CheckBuy:'Tarkista ostos',
Exists:'Olemassa',
NetworkUnavailable:'Verkko ei ole käytettävissä',
Today:'Tänään',
Yesterday:'Eilen',
ThisMonth:'Tässä kuussa',
LastMonth:'Viime kuukausi',
nickname:'Nimimerkki',
storeName:'myymälän nimi',
BuyStandAlone:'Osta itsenäinen versio',
PermissionDenied:'Lupa kielletty',
Boss:'Boss',
    login:'Kirjaudu sisään',
    operate:'toimia',
    register:'Rekisteröidy',
    username:'Käyttäjänimi',
    password:'Salasana',
    User:'käyttäjä',
    ok:'kunnossa',
    back:'Takaisin',
    success:'Menestys',
    fail:'epäonnistua',
    cancel:'peruuttaa',
    add:'Lisätä',
    edit:'muokata',
    delete:'Poistaa',
    refresh:'virkistää',
    close:'kiinni',
    cancel:'Peruuttaa',
    return:'Palata',
    ElinkInvoice:'Elink-lasku',
    Purchase:'Ostaa',
    BaseData:'Perustiedot',
    Sell:'Myydä',
    PurchaseReturns:'Ostotuotot',
    SellReturns:'Myy tuottoja',
    Inventory:'inventaario',
    Statistics:'tilasto',
    Receivable:'Myyntisaamiset',
    Payable:'Maksettava',
    Orders:'tilaukset',
    StockTransfer:'Varastosiirto',
    StockRecall:'Stock Recall',
    Customer:'asiakas',
    Supplier:'toimittaja',
    Warehouse:'Varasto',
    Color:'Väri',
    Size:'Koko',
    Category:'Kategoria',
    Category2:'Luokka2',
    Product:'Tuote',
    Account:'Tili',
    AccountType:'Tilin luokka',
    Staff:'henkilöstö',
    typeone:'Kategoria',
    typetwo:'Alaluokka',
    ProductName:'Tuotteen nimi',
    Specification:'määrittely',
    Barcode:'Viivakoodi',
    Buyprice:'Osta hinta',
    Sellprice:'Myy hinta',
    Wholesaleprice:'Tukkuhinta',
    Currentstock:'Varastotilanne',
    Unit:'yksikkö',
    Initstock:'Init-varastot',
    Parameter:'Parametri',
    Remark:'Huomautus',
    Supplier:'toimittaja',
    Customer:'asiakas',
    Staff:'henkilöstö',
    Receivable:'Myyntisaamiset',
    payable:'maksettava',
    Receipts:'tulot',
    Paid:'Maksettu',
    Preferential:'etuoikeutettu',
    DateDay:'Treffi',
    OrderNum:'Tilausnumero',
    Name:'Nimi',
    UserName:'Käyttäjänimi',
    IdNum:'ID-numero',
    BirthDay:'Syntymäpäivä',
    SEX:'sukupuoli',
    Female:'Nainen',
    Male:'Uros',
    Select:'valita',
    Address:'Osoite',
    Phone:'Puhelin',
    Email:'Sähköposti',
    CardNum:'Kortin numero',
    Price:'Hinta',
    QTY:'Määrä',
    SupplierCategory:'Toimittajaluokka',
    CustomerCategory:'Asiakasluokka',
    Power:'teho',
    Role:'Rooli',
    save:'Tallentaa',
    image:'kuva',
    search:'Hae',
    Year:'vuosi',
    Month:'Kuukausi',
    Day:'Päivä',
    Total:'Kaikki yhteensä',
    WorkReport:'Työraportti',
    Leave:'jättää',
    CheckIn:'Ilmoittautua',
    Announcement:'Ilmoitus',
    Approval:'Hyväksyminen',
    Tracking:'Seuranta',
    Bill:'Laskuttaa',
    OrdersDetail:'Tilausten tiedot',
    Expense:'kulu',
    Income:'Tulo',
    Userfor:'Käyttäjä käyttäjälle',
    Amount:'Määrä',
    Title:'otsikko',
    News:'Uutiset',
    SelectFile:'Valitse tiedosto',
    Content:'pitoisuus',
    Cost:'Kustannus',
    ApprovalUser:'Hyväksynnän käyttäjä',
    ApprovalStatus:'Hyväksynnän tila',
    ApprovalRemark:'Hyväksyntähuomautus',
    ApprovalDate:'Hyväksymispäivä',
    SubmitDate:'Lähetä päivämäärä',
    Status:'Status',
    FromDateTime:'Päivämäärästä',
    ToDateTime:'Päivämäärän kellonaika',
    Subject:'aihe',
    Latitude:'leveysaste',
    Longitude:'pituusaste',
    Print:'Tulosta',
    DataTrans:'Data Trans',
    OA:'OA',
    Setting:'Sarja',
    Help:'auta',
    ScanOpenInPhone:'Skannaa Avaa puhelimessa',
    Building:'Rakennus',
    Room:'Huone',
    HotelCheckIn:'Ilmoittautua',
    CheckOut:'Tarkista',
    Hotel:'Hotelli',
    Checkintime:'Tarkistaa ajoissa',
    Checkouttime:'Tarkista aika',
    Deposit:'Tallettaa',
    Cost:'Kustannus',
    RoomNum:'Huone Num',
    Rent:'Vuokrata',
    costday:'costday',
    rent:'vuokrata',
    waternum:'Vesiaste',
    electricnum:'Sähköinen tutkinto',
    gasnum:'Kaasututkinto',
    watercost:'veden kustannukset',
    electriccost:'sähköiset kustannukset',
    gascost:'kaasun kustannukset',
    cleaningcost:'siivouskulut',
    networkcost:'verkon kustannukset',
    tvcost:'tv-hinta',
    managecost:'hallita kustannuksia',
    othercost:'muut kustannukset',
    totalcost:'kokonaiskustannukset',
    remark:'huomautus',
    addtime:'lisää aikaa',
    OpenInBrowser:'Avaa selaimessa',
    InventoryProfit:'Varaston voitto',
    InventoryLoss:'Varastohävikki',
    Buy:'Ostaa',



Refresh:'Päivitä',
Add:'Lisää',
Search:'Hae',
Records:'tietuetta',
}



// WEBPACK FOOTER //
// ./src/lang/fi.js